import { useEffect, useState } from "react";
import { api, apiError, eur, deDate } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Printer, Mail, Ban } from "lucide-react";

export default function Rechnungen() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/invoices").then((r) => setInvoices(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const printInvoice = async (id) => {
    const { data } = await api.get(`/invoices/${id}/pdf`, { responseType: "blob" });
    window.open(URL.createObjectURL(new Blob([data], { type: "application/pdf" })), "_blank");
  };

  const resend = async (id) => {
    try {
      const { data } = await api.post(`/invoices/${id}/send-email`);
      toast.success(`Rechnung gesendet an ${data.sent_to}`);
      load();
    } catch (e) { toast.error(apiError(e, "Versand fehlgeschlagen")); }
  };

  const storno = async (id) => {
    if (!window.confirm("Rechnung wirklich stornieren?")) return;
    try {
      const { data } = await api.post(`/invoices/${id}/storno`);
      toast.success(`Storniert – Gutschrift ${data.storno_number} erstellt.`);
      load();
    } catch (e) { toast.error(apiError(e, "Storno fehlgeschlagen")); }
  };

  return (
    <div className="space-y-6" data-testid="rechnungen-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-wider text-zinc-400">Verkauf</div>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight mt-1">Rechnungen</h1>
      </div>
      <div className="bg-white border border-zinc-200 rounded-xl shadow-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="border-b border-zinc-100 text-left">
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400">Nr.</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400">Datum</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400">Kunde</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400">Steuer</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400">Status</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400 text-right">Betrag</th>
            <th className="px-5 py-3"></th>
          </tr></thead>
          <tbody className="divide-y divide-zinc-50">
            {loading && <tr><td colSpan={7} className="px-5 py-8 text-center text-zinc-400 font-mono text-xs">Laden…</td></tr>}
            {!loading && invoices.length === 0 && <tr><td colSpan={7} className="px-5 py-8 text-center text-zinc-400">Noch keine Rechnungen.</td></tr>}
            {invoices.map((i) => (
              <tr key={i.id} className="hover:bg-zinc-50" data-testid={`invoice-row-${i.number}`}>
                <td className="px-5 py-3 font-mono text-xs">{i.number}</td>
                <td className="px-5 py-3 text-zinc-600">{deDate(i.date)}</td>
                <td className="px-5 py-3">{i.customer_name}</td>
                <td className="px-5 py-3 text-xs text-zinc-500">{i.tax_label || { differenz: "§25a Differenzbesteuerung", regel: `${i.tax_rate} % Umsatzsteuer`, frei: "0 % / steuerfrei", ku19: "§19 UStG" }[i.tax_mode] || i.tax_mode}</td>
                <td className="px-5 py-3">{i.status === "storniert" ? <span className="text-[10px] font-mono bg-red-50 text-red-700 border border-red-200 px-2 py-0.5 rounded-full">storniert</span> : <span className="text-[10px] font-mono bg-zinc-900 text-white px-2 py-0.5 rounded-full">{i.payment_status}</span>}</td>
                <td className="px-5 py-3 text-right font-medium">{eur(i.total)}</td>
                <td className="px-5 py-3 text-right whitespace-nowrap">
                  <Button variant="outline" size="sm" onClick={() => printInvoice(i.id)} data-testid={`invoice-pdf-${i.number}`} className="min-h-[40px]"><Printer className="w-3.5 h-3.5 mr-1" /> PDF</Button>
                  {i.status !== "storniert" && <Button variant="outline" size="sm" onClick={() => resend(i.id)} data-testid={`invoice-email-${i.number}`} className="ml-1 min-h-[40px]"><Mail className="w-3.5 h-3.5" /></Button>}
                  {i.status !== "storniert" && <Button variant="outline" size="sm" onClick={() => storno(i.id)} data-testid={`invoice-storno-${i.number}`} className="ml-1 min-h-[40px] text-red-600 border-red-200"><Ban className="w-3.5 h-3.5" /></Button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
